// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__13qLn","label":"Labeled_label__gba8g","divider":"Labeled_divider__14ONz"};